import customSelect from "custom-select/src";

class CustomSelect {
  constructor(element) {
    this.instance = customSelect(element);
  }
}

export default class Disclaimer {
  constructor() {
    this.state = {
      cookie: {
        country: null,
        investorType: null,
      },
      url: {
        country: null,
        investorType: null,
        path: null,
        params: null,
      },
      contentHidden: false,
      disclaimerDisplayed: false,
    };

    // this.modal = null;
    this.isOpen = false;

    // ConsentBox instance
    // this.cookieBox = null;

    this.cookieName = "disclaimer";
    this.cookieMaxAge = 60 * 60 * 24 * 365;

    this.disclaimerUriPath = "disclaimer";

    this.disclaimerNode = null;
    this.contentNodes = [];
    this.formNode = null;
    this.languageNode = null;
    this.countryNode = null;
    this.investorTypeNodes = null;
    this.acceptNode = null;
    this.rememberMeNode = null;
    this.customSelectResidence = null;
    this.languageMenuNodes = null;

    this.formInited = false;

    this.eventHandlers = [];
    this.formEventHandlers = [];
    // this.cookieBox = cookieBox;

    // this.bindCookieBoxEvents();

    this.parseUrl();
    this.parseCookie();

    if (
      this.getHasCookie() &&
      !this.getUrlAndCookieStateMatch() &&
      this.getHasGeneralDimension()
    ) {
      window.location.href = this.buildUrl(this.state.cookie);
    }

    document.addEventListener("swup:willReplaceContent", () => {
      this.destroyForm();
    });
  }

  // initDisclaimerModal() {
  //     this.modal = basicLightbox.create(document.querySelector(".disclaimer__container"), {
  //         className: "basicLightbox--navigation",
  //         onShow: () => {
  //             this._scrollPosition = window.pageYOffset;
  //             document.body.classList.add("basicLightbox--enabled");
  //             document.body.style.top = `-${this._scrollPosition}px`;
  //         },
  //         onClose: () => {
  //             document.body.classList.remove("basicLightbox--enabled");
  //             document.body.style.top = null;
  //             window.scrollTo({
  //                 top: this._scrollPosition,
  //                 behavior: "instant",
  //             });
  //         },
  //     });
  // }

  getHasCookie() {
    return !!(this.state.cookie.investorType && this.state.cookie.country);
  }

  getUrlAndCookieStateMatch() {
    return (
      this.getHasCookie() &&
      this.getStatesMatch(this.state.cookie, this.state.url)
    );
  }

  getStatesMatch(state1, state2) {
    return (
      state1.investorType === state2.investorType &&
      state1.country === state2.country
    );
  }

  getHasGeneralDimension() {
    //@todo get the 'all' values from some config, should be passed from neos via tag attributes
    return (
      this.state.url.country === "all" || this.state.url.investorType === "all"
    );
  }

  parseCookie() {
    const allCookies = Object.fromEntries(
      document.cookie
        .split(/; */)
        .filter((c) => c !== "")
        .map((c) => {
          const [key, v] = c.split("=", 2);
          return [key, decodeURIComponent(v)];
        })
    );

    if (typeof allCookies[this.cookieName] !== "undefined") {
      try {
        const cookie = JSON.parse(allCookies[this.cookieName]);

        //@todo validate cookie values!
        this.state.cookie.investorType = cookie.investorType || null;
        this.state.cookie.country = cookie.country || null;
      } catch (e) {
        console.error("Could not parse disclaimer cookie value", e);
      }
    }
  }

  setCookie(country, investorType, rememberMe = false) {
    const cookieContent = JSON.stringify({
      country,
      investorType,
    });

    document.cookie =
      this.cookieName +
      "=" +
      cookieContent +
      "; path=/; SameSite=strict; Secure" +
      (rememberMe ? ";max-age=" + this.cookieMaxAge : "");
  }

  parseUrl() {
    const path = window.location.pathname.replace(/^\/(.*)$/, "$1");
    const pathSplitted = path.split("/");
    const dimensionsPath = pathSplitted.shift();
    const dimensions = dimensionsPath.split("-").filter((c) => c !== "");
    const params = new URLSearchParams(window.location.search);

    this.state.url.country = dimensions[0] || "all";
    this.state.url.investorType = pathSplitted.shift() || "all";
    this.state.url.path = pathSplitted.join("/");
    this.state.url.params = params.toString();

    if (params.has("disclaimer-accepted") && !this.getHasGeneralDimension()) {
      this.setCookie(this.state.url.country, this.state.url.investorType);
    }

  }

  buildUrl(state, path) {
    state = state || this.state.cookie;
    path = path || this.state.url.path;
    const fallbackLanguage = document
      .querySelector("html")
      .getAttribute("lang");

    const uri =
      "/" +
      state.country +
      "-" +
      (state.language || fallbackLanguage) +
      "/" +
      state.investorType +
      "/" +
      path;

    return this.state.url.params.length > 0
      ? uri + "?" + this.state.url.params
      : uri;
  }

  getDisclaimerReferences() {
    this.disclaimerNode = document.getElementById("disclaimer");
    const disclaimerUri = this.disclaimerNode.getAttribute(
      "data-disclaimer-uri"
    );
    this.disclaimerUriPath = disclaimerUri.replace(
      /^\/([^\/]*)\/([^\/]*)\/?(.*?)$/,
      "$3"
    );
  }

  checkDisclaimer() {
    this.getDisclaimerReferences();

    if (!this.getUrlAndCookieStateMatch()) {
      this.showDisclaimer();
    } else {
      this.hideDisclaimer();
    }
  }

  checkContent() {
    this.contentNodes = document.querySelectorAll(
      ".meta-nav, header, main, footer"
    );

    if (!this.getUrlAndCookieStateMatch()) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  hideDisclaimer() {
    this.disclaimerNode.classList.add("disclaimer--hidden");
    document.body.classList.remove("basicLightbox--enabled");
    this.state.disclaimerDisplayed = false;
  }

  showDisclaimer() {
    if (this.isSearchEngine()) {
      return;
    }

    document.body.classList.add("basicLightbox--enabled");
    this.disclaimerNode.classList.remove("disclaimer--hidden");

    this.state.disclaimerDisplayed = true;

    this.initForm();
    // this.initDisclaimerModal();

    // this.modal.show();
  }

  getIsDisclaimerDisplayed() {
    return this.state.disclaimerDisplayed;
  }

  hideContent() {
    if (this.isSearchEngine()) {
      return;
    }

    if (this.contentNodes.length > 0) {
      this.contentNodes.forEach((node) => {
        node.classList.add("pointer-events-none");
      });
    }

    this.state.contentHidden = true;
  }

  showContent() {
    if (this.state.contentHidden && this.contentNodes.length > 0) {
      this.contentNodes.forEach((node) => {
        node.classList.remove("pointer-events-none");
      });

      this.state.contentHidden = false;
      window.dispatchEvent(new CustomEvent("contentShow"));
    }
  }

  getIsContentHidden() {
    return this.state.contentHidden;
  }

  triggerDisclaimer() {
    this.hideContent();
    this.showDisclaimer();
  }

  getFormNodes() {
    this.formNode = this.disclaimerNode.querySelector("form");
    this.languageNode = this.formNode.querySelector('input[name="language"]');
    this.countryNode = this.formNode.querySelector("select#country");
    this.investorTypeNodes = this.formNode.querySelectorAll(
      'input[name="investorType"]'
    );
    this.acceptNode = this.formNode.querySelector(".accept-button");
    this.rememberMeNode = this.formNode.querySelector("#rememberMe");
    this.triggers = document.querySelectorAll("[data-disclaimer-trigger]");
    this.languageMenuNodes = document.querySelectorAll("[data-lang]");
  }

  bindFormEvents() {
    this.bindFormEvent({
      element: this.formNode,
      handler: (event) => this.formSubmitHandler(event),
      event: "submit",
    });
    this.bindFormEvent({
      element: this.acceptNode,
      handler: (event) => this.acceptHandler(event),
      event: "click",
    });
    this.bindFormEvent({
      element: this.countryNode,
      handler: (event) => this.changeParamsHandler(event),
      event: "change",
    });
    [].forEach.call(this.investorTypeNodes, (investorNodeType) => {
      this.bindFormEvent({
        element: investorNodeType,
        handler: (event) => this.changeInvestorTypeHandler(event),
        event: "change",
      });
    });
    [].forEach.call(this.languageMenuNodes, (languageMenuNode) => {
      this.bindFormEvent({
        element: languageMenuNode,
        handler: (event) => {
          event.preventDefault();
          this.languageNode.value = languageMenuNode.getAttribute("data-lang");
          this.changeParamsHandler(event);
        },
        event: "click",
      });
    });
  }

  bindFormEvent(eventData) {
    eventData.element.addEventListener(eventData.event, eventData.handler);
    this.formEventHandlers.push(eventData);
  }

  unbindFormEvents() {
    this.formEventHandlers.forEach(
      eventData => eventData.element.removeEventListener(eventData.event, eventData.handler)
    );
  }

  bindEvents() {
    [].forEach.call(this.triggers, (trigger) => {
      this.bindEvent({
        element: trigger,
        handler: () => this.showDisclaimer(),
        event: "click",
      });
    });
  }

  bindEvent(eventData) {
    eventData.element.addEventListener(eventData.event, eventData.handler);
    this.eventHandlers.push(eventData);
  }

  unbindEvents() {
    this.eventHandlers.forEach(
      eventData => eventData.element.removeEventListener(eventData.event, eventData.handler)
    );
  }

  formSubmitHandler(event) {
    event.preventDefault();
  }

  acceptHandler(event) {
    const formValues = this.getFormValues();

    this.setCookie(
      formValues.country,
      formValues.investorType,
      formValues.rememberMe
    );

    this.state.cookie.country = formValues.country;
    this.state.cookie.investorType = formValues.investorType;

    if (this.getUrlAndCookieStateMatch()) {
      this.hideDisclaimer();
      this.showContent();
      this.notifyDisclaimerHidden();
    } else {
      // setTimeout(() => window.location.href = this.buildUrl(formValues), 0);
      window.location.href = this.buildUrl(formValues);
    }
  }

  changeParamsHandler(event) {
    const formValues = this.getFormValues();

    this.togglePreloader("SHOW");

    //@todo cache responses
    fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        this.buildUrl(formValues, this.disclaimerUriPath)
    )
      .then((response) => response.text())
      .then((responseHtml) => {
        const tmpNode = document.createElement("html");
        tmpNode.innerHTML = responseHtml;
        const newDisclaimerNode = tmpNode.querySelector("#disclaimer");
        newDisclaimerNode.classList.remove("disclaimer--hidden");
        this.destroyForm();
        this.disclaimerNode.replaceWith(newDisclaimerNode);
        this.disclaimerNode = document.getElementById("disclaimer");
        this.initForm();
        this.togglePreloader("HIDE");
      });
    //@todo error handling
  }

  getFormValues() {
    const investorTypeNodesFiltered = [].filter.call(
      this.investorTypeNodes,
      (investorTypeNode) => investorTypeNode.checked
    );
    const investorType = investorTypeNodesFiltered.length
      ? investorTypeNodesFiltered[0].value
      : null;

    return {
      language: this.languageNode.value,
      country: this.countryNode.value,
      investorType: investorType,
      rememberMe: !!this.rememberMeNode.checked,
    };
  }

  initForm() {
    if (this.formInited) {
      return;
    }

    this.getFormNodes();
    this.bindFormEvents();
    this.createCustomSelect();
    this.bindEvents();

    this.formInited = true;
  }

  destroyForm() {
    this.unbindFormEvents();
    this.unbindEvents();

    if (this.customSelectResidence) {
      this.countryNode.customSelect.destroy();
      this.customSelectResidence = null;
    }

    this.formInited = false;
  }

  createCustomSelect() {
    this.customSelectResidence = new CustomSelect(this.countryNode);
  }

  togglePreloader(state) {
    if (state == "SHOW") {
      return this.disclaimerNode.classList.add("disclaimer--loading");
    }

    return this.disclaimerNode.classList.remove("disclaimer--loading");
  }

  notifyDisclaimerHidden() {
    window.dispatchEvent(new CustomEvent("disclaimer:hidden"));
  }

  bindCookieBoxEvents() {
    window.addEventListener("cookieBox:accepted", (event) => {
      // setTimeout(() => {
      this.checkDisclaimer();
      // });
    });
  }

  isSearchEngine() {
    // on changes head over to head over to DistributionPackages/Bellevue.Disclaimer/Resources/Private/Fusion/Component/ConsentBox/ConsentBox.js too..
    const detectRobot = (userAgent) => {
      const robots = new RegExp(
        [
          /bot/,
          /spider/,
          /crawl/, // GENERAL TERMS
          /APIs-Google/,
          /AdsBot/,
          /Googlebot/, // GOOGLE ROBOTS
          /mediapartners/,
          /Google Favicon/,
          /FeedFetcher/,
          /Google-Read-Aloud/,
          /DuplexWeb-Google/,
          /googleweblight/,
          /bing/,
          /yandex/,
          /baidu/,
          /duckduck/,
          /yahoo/, // OTHER ENGINES
          /ecosia/,
          /ia_archiver/,
          /facebook/,
          /instagram/,
          /pinterest/,
          /reddit/, // SOCIAL MEDIA
          /slack/,
          /twitter/,
          /whatsapp/,
          /youtube/,
          /semrush/, // OTHER
          // /chrome/,                                         // OTHER
        ]
          .map((r) => r.source)
          .join("|"),
        "i"
      ); // BUILD REGEXP + "i" FLAG

      return robots.test(userAgent);
    };

    return detectRobot(navigator.userAgent);
  }
}
